import type { ReactNode } from 'react'
import { useDevFlag } from '@/services/analytics/dev-flags'
import type { DevFlagKey } from '@/services/analytics/feature-flags'

/**
 * RolloutGate for a dev-tool panel behind a PostHog dev flag (DEV_FLAGS). A
 * panel saved into a layout while its flag was on renders this notice instead
 * once the flag is off (including while PostHog loads, since dev flags read
 * off until PostHog says on). The lazy panel's chunk is never requested while
 * off. The panel header (and its close control) still renders around it.
 */
export function DevFlagGate({ flag, children }: { flag: DevFlagKey; children: ReactNode }) {
  const on = useDevFlag(flag)
  if (!on) {
    return (
      <div className="flex h-full w-full items-center justify-center p-4 text-center">
        <p className="text-sm text-muted-foreground">
          This panel isn't available for your account.
        </p>
      </div>
    )
  }
  return <>{children}</>
}
